"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RULE_MANAGER_DATA_CHANGE = exports.CHANGED_RULE_STACK_WINDOW = exports.DELETE_RULE = exports.UPDATE_RULE = exports.ADD_RULE = exports.CHANGE_RULE_MODEL_SAGA = exports.SHOW_RULE_SAGA = exports.CLONE_RULE = exports.OPEN = exports.LOAD = void 0;
exports.LOAD = 'RULE_MANAGER.LOAD';
exports.OPEN = 'RULE_MANAGER.OPEN';
exports.CLONE_RULE = 'RULE_MANAGER.CLONE_RULE';
exports.SHOW_RULE_SAGA = 'RULE_MANAGER.SHOW_RULE_SAGA';
exports.CHANGE_RULE_MODEL_SAGA = 'RULE_MANAGER.CHANGE_RULE_MODEL_SAGA';
exports.ADD_RULE = 'RULE_MANAGER.ADD_RULE';
exports.UPDATE_RULE = 'RULE_MANAGER.UPDATE_RULE';
exports.DELETE_RULE = 'RULE_MANAGER.DELETE_RULE';
exports.CHANGED_RULE_STACK_WINDOW = 'RULE_MANAGER.CHANGED_RULE_STACK_WINDOW';
exports.RULE_MANAGER_DATA_CHANGE = 'RULE_MANAGER.RULE_MANAGER_DATA_CHANGE';
//# sourceMappingURL=actionTypes.js.map